import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Chip, Stack, Typography } from '@mui/material';

import { PDFViewer } from 'components/PDFViewer/PDFViewer';
import { ImageViewer } from 'components/ImageViewer/ImageViewer';
import { FileListItem } from 'features/frameworkAgreements/components/FileListItem';
import { donwloadFileFromURL } from 'features/frameworkAgreements/api/downloadFile';

import { downloadQnaFile, useQnaFilePreview } from '../api/getQnaFile';

export const QnaFiles = ({ resource, id, files, heading = 'Attachments' }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [previewId, setPreviewId] = useState(null);
  const { data: preview } = useQnaFilePreview(resource, id, previewId);

  if (!files?.length) return null;

  const handleDownload = (fileId) =>
    downloadQnaFile(resource, id, fileId).catch(() =>
      enqueueSnackbar('Failed to download file', { variant: 'error' })
    );

  const closePreview = () => setPreviewId(null);
  const handlePreviewDownload = () => donwloadFileFromURL(preview.url, preview.name);
  const previewing = !!previewId && !!preview?.url;

  return (
    <Stack gap={0.5}>
      <Typography variant="caption" fontWeight={700} color="text.secondary">
        {heading}
      </Typography>
      {files.map((file) => (
        <Stack key={file.file_id} direction="row" alignItems="center" gap={1}>
          <Box flex={1} minWidth={0}>
            <FileListItem
              name={file.name}
              mime_type={file.mime_type ?? ''}
              showCreated={false}
              handleFilePreview={() => setPreviewId(file.file_id)}
              handleDownload={() => handleDownload(file.file_id)}
            />
          </Box>
          {file.public === false && <Chip size="small" label="Not published" variant="outlined" />}
        </Stack>
      ))}

      <PDFViewer
        url={preview?.url}
        open={previewing && preview.mimeType.includes('application/pdf')}
        close={closePreview}
        handleDownload={handlePreviewDownload}
        canDownload
      />
      <ImageViewer
        url={preview?.url}
        open={previewing && preview.mimeType.includes('image/')}
        close={closePreview}
        handleDownload={handlePreviewDownload}
      />
    </Stack>
  );
};
